import Vue from 'vue'
import Vuex, { Module } from 'vuex'
import { vuexfireMutations, firestoreAction } from 'vuexfire'
import firebase from 'firebase/app'

import { db, FieldValue, Timestamp } from '../db'

const FETCH_LIMIT = 16

export const publicDeck: Module<any, any> = {
    state: {
        decks: [],
        cursor: {
            head: null,
            tail: null,
        },
        hasPreviousPage: false,
        hasNextPage: false,
        currentPage: -1,
        loadingCreation: false,
        editingDeck: null,
    },
    mutations: {
        ...vuexfireMutations,
        setPublicDecks: (state, { decks, head, tail }) => {
            state.decks = decks
            if (head && tail) {
                state.cursor.head = head
                state.cursor.tail = tail
            }
            state.hasNextPage = decks.length >= FETCH_LIMIT
        },
        incrementCurrentPage: (state) => {
            state.currentPage++
        },
        decrementCurrentPage: (state) => {
            state.currentPage--
        },
        setPage: (state, { decks }) => {
            state.hasNextPage = decks.length >= FETCH_LIMIT
            state.hasPreviousPage = state.currentPage > 0
        },
        setLoadingCreation: (state, { loading }) => {
            state.loadingCreation = loading
        },
        setEditingDeck: (state, { deck }) => {
            state.editingDeck = deck
        }
    },
    actions: {
        fetchNextPublicDecks({ commit, state }) {
            let ref = db.collection('decks')
                .where('visibility', '==', 'public')
                .orderBy("createdAt", "desc")
                .limit(FETCH_LIMIT)
            if (state.cursor.head) {
                ref = ref.startAfter(state.cursor.head)
            }
            ref.get()
                .then(snapshot => {
                    if (snapshot.empty) {
                        commit('setPage', { decks: [] })
                        return
                    }
                    const decks = snapshot.docs.map(doc => doc.data())
                    commit('setPublicDecks', { decks, head: snapshot.docs[snapshot.docs.length - 1], tail: snapshot.docs[0] })
                    commit('incrementCurrentPage')
                    commit('setPage', { decks })
                })
        },
        fetchPreviousPublicDecks({ commit, state }) {
            let ref = db.collection('decks')
                .where('visibility', '==', 'public')
                .orderBy("createdAt", "asc")
                .limit(FETCH_LIMIT)
            if (state.cursor.tail) {
                ref = ref.startAfter(state.cursor.tail)
            }
            ref.get()
                .then(snapshot => {
                    if (snapshot.empty) {
                        commit('setPage', { decks: [] })
                        return
                    }
                    const decks = snapshot.docs.map(doc => doc.data())
                    commit('setPublicDecks', { decks, head: snapshot.docs[0], tail: snapshot.docs[snapshot.docs.length - 1] })
                    commit('decrementCurrentPage')
                    commit('setPage', { decks })
                })
        },
    },
    getters: {
        getPublicDecks: (state) => {
            return state.decks.sort((a: any, b: any) => a.createdAt.toDate() > b.createdAt.toDate() ? -1 : 1)
        },
        hasPreviousPage: (state) => {
            return state.hasPreviousPage
        },
        hasNextPage: (state) => {
            return state.hasNextPage
        }
    }
}